import React from 'react';
import styles from './CreateNewsHeader.module.scss';
import floppyIcon from '../../../assets/Imagess/floppy-white.svg';
import draftIcon from '../../../assets/Imagess/draft.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import previewIcon from '../../../assets/Imagess/preview.svg';

const CreateNewsHeader = ({
  handleSubmit,
  title,
  onPreviewClick,
  singleButton,
}) => {
  return (
    <div className={styles['add-programs-header']}>
      <div>
        <p className={styles['title']}>{title}</p>
      </div>
      <div className={styles['icon-subcontainer']}>
        {singleButton ? null : (
          <Buttons
            text='معاينة'
            icon={previewIcon}
            rounded={true}
            color='rgba(13, 160, 110, 1)'
            handleOnClick={onPreviewClick}
            style={{ fontFamily: 'BukraMedium' }}
          />
        )}

        <Buttons
          text='حفظ'
          icon={floppyIcon}
          rounded={true}
          color='rgba(13, 160, 110, 1)'
          handleOnClick={() => handleSubmit()}
          style={{ fontFamily: 'BukraMedium' }}
        />
      </div>
    </div>
  );
};

export default CreateNewsHeader;
